import React from "react";
import { EuiFlexGroup, EuiFlexItem, EuiLink } from "@elastic/eui";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import configureStore from "../../../app/store";
import AbstractColumnActions from "../../shared/entity/TableColumnAction";
import { clearCommentStates } from "../../shared/Comments/commentSlice";

const store = configureStore;
const columns = (actions) => [
    {
        field: "id",
        name: "ID",
        render: (item) => (
            <span>
                <EuiLink>#{item}</EuiLink>
            </span>
        ),
        sortable: true,
        width: 70,
    },
    {
        field: "organizationName",
        name: <FormattedMessage id="order.client-name" />,
        sortable: true,
        render: (item) => <b>{item}</b>,
        mobileOptions: {
            render: (item) => <b>{item.organizationName}</b>,
            header: false,
            truncateText: false,
            enlarge: true,
            fullWidth: true,
        },
    },
    {
        field: "requestedAt",
        name: <FormattedMessage id="order.request-date" />,
        dataType: "date",
        sortable: true,
    },
    {
        field: "status",
        name: <FormattedMessage id="order.status" />,
        sortable: true,
    },
    {
        field: "createdAt",
        name: <FormattedMessage id="order.created-at" />,
        dataType: "date",
        sortable: false,
    },
    {
        field: "tripIds",
        name: <FormattedMessage id="order.trips-list" />,
        sortable: true,
        render: (colValue) => renderTripIds(colValue),
    },
    {
        field: "platformType",
        name: <FormattedMessage id="order.platform" />,
        sortable: true,
    },
    {
        name: "Actions",
        isActionsPopover: true,
        actions: AbstractColumnActions(actions),
    },
];
const clearCommentStore = () => {
    store.dispatch(clearCommentStates());
};
export function renderTripIds(tripIds) {
    return (
        <EuiFlexGroup
            gutterSize="xs"
            wrap
        >
            {tripIds?.map((val) => (
                <EuiFlexItem
                    key={val}
                    style={{ whiteSpace: "nowrap" }}
                >
                    <Link
                        className="link-list__item"
                        to={`/database/trips/${val}`}
                        onClick={clearCommentStore()}
                    >
                        #{val}
                    </Link>
                </EuiFlexItem>
            ))}
        </EuiFlexGroup>
    );
}

export default columns;
